import { MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { waLink, WHATSAPP_DISPLAY } from "@/lib/whatsapp";

export const FinalCta = () => (
    <section id="contato" data-testid="final-cta-section" className="relative overflow-hidden py-24 sm:py-32">
        <div className="pointer-events-none absolute inset-0" aria-hidden="true">
            <div className="absolute left-1/2 top-1/2 h-[380px] w-[680px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#25D366]/[0.08] blur-[120px]" />
        </div>
        <div className="relative mx-auto max-w-3xl px-5 text-center sm:px-8">
            <Reveal>
                <span className="text-xs font-bold uppercase tracking-[0.24em] text-cyan-400">
                    Contato Direto
                </span>
                <h2 className="mt-4 text-3xl font-bold tracking-tight text-slate-50 sm:text-5xl">
                    Pronto para destravar a tecnologia do seu comércio no Campo Limpo?
                </h2>
                <p className="mx-auto mt-5 max-w-xl text-base text-slate-400 sm:text-lg">
                    Fale agora com a Strondex Tech no WhatsApp. Respondemos em poucos
                    minutos — sem robôs, sem fila.
                </p>
                <a
                    href={waLink("general")}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="final-cta-whatsapp-button"
                    className="mt-9 inline-flex items-center gap-2.5 rounded-full bg-[#25D366] px-9 py-4 text-base font-bold text-[#052e12] transition-all duration-300 hover:-translate-y-1 hover:bg-[#2ce06f] hover:shadow-[0_16px_48px_rgba(37,211,102,0.4)]"
                >
                    <MessageCircle size={20} strokeWidth={2.5} />
                    Chamar no WhatsApp Agora
                </a>
                <p data-testid="final-cta-phone" className="mt-5 text-sm text-slate-500">
                    {WHATSAPP_DISPLAY} · Campo Limpo, São Paulo — SP
                </p>
            </Reveal>
        </div>
    </section>
);
